<template>
  <div>
    <v-dialog v-model="showLicenceFeaturesDialog" width="480" @click:outside="closeLicenceKeyFeature()">
      <div class="ec-dialog">
        <div class="ec-dialog__header">
          <h2 class="ec-dialog__title">
            Features
            <span class="lkf-licence-name">{{ licenceName }}</span>
          </h2>
          <button class="ec-icon-btn" @click="closeLicenceKeyFeature">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </div>
        <div class="ec-dialog__body" style="padding:0">
          <v-data-table dense :headers="headersFeature" :items="features" class="ec-table">
            <template v-slot:[`item.label`]="{ item }">
              <span>{{ item.feature_name }}</span>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    features: { type: Array, default: () => [] },
    showLicenceFeaturesDialog: { type: Boolean, default: false },
    licenceName: { type: String, default: '' }
  },
  data () {
    return {
      headersFeature: [
        { text: 'Name', value: 'label', align: 'left' },
        { text: 'Limit', value: 'limit', align: 'center' }
      ]
    }
  },
  methods: {
    closeLicenceKeyFeature () {
      this.$emit('closeLicenceKeyFeature')
    }
  }
}
</script>

<style scoped>
.lkf-licence-name {
  font-size: .8rem;
  font-weight: 500;
  color: var(--ec-primary);
  margin-left: 8px;
  padding: 2px 8px;
  background: var(--ec-primary-bg);
  border-radius: 20px;
}

/* Table → global .ec-table in admin.css */
</style>
